import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_APP_CONFIG_REQUEST = 'appConfig/FETCH_APP_CONFIG_REQUEST'
const FETCH_APP_CONFIG_SUCCESS = 'appConfig/FETCH_APP_CONFIG_SUCCESS'
const FETCH_APP_CONFIG_FAILURE = 'appConfig/FETCH_APP_CONFIG_FAILURE'

const UPDATE_APP_CONFIG_REQUEST = 'appConfig/UPDATE_APP_CONFIG_REQUEST'
const UPDATE_APP_CONFIG_SUCCESS = 'appConfig/UPDATE_APP_CONFIG_SUCCESS'
const UPDATE_APP_CONFIG_FAILURE = 'appConfig/UPDATE_APP_CONFIG_FAILURE'

// Initialize State
const initialState = {
  isLoading: false,
  error: {},
  appConfig: [],
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_APP_CONFIG_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_APP_CONFIG_SUCCESS:
      return {
        ...state,
        isLoading: false,
        appConfig: action.payload
      }
    case FETCH_APP_CONFIG_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_APP_CONFIG_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_APP_CONFIG_REQUEST:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_APP_CONFIG_REQUEST:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

// Action Creators
export const fetchAppConfig = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_APP_CONFIG_REQUEST
      })
      const response = await API.get(EndPoints.APP_CONFIG + `/all`)
      dispatch({
        type: FETCH_APP_CONFIG_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_APP_CONFIG_FAILURE
      })
    }
  }
}
export const updateValue = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_APP_CONFIG_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.APP_CONFIG + `/updateValue`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_APP_CONFIG_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_APP_CONFIG_FAILURE
      })
    }
  }
}


